import { storeList } from '@/api/domain/shop'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const configData = {
    formData: {
      formProps: {
        ref: 'searchForm',
      },
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '门店名称',
            prop: 'name',
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '创建时间',
            prop: 'createTime',
          },
        },
      ],
      dealWithSearch: this.dealWithSearch,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '门店ID',
            prop: 'id',
            width: 160,
          },
          render: ({ row }) => {
            if (!this.judgePermission('company_store_detail')) return row.id
            return <span class="a-hover-link" onClick={() => this.handleToStoreDetail(row)}>{row.id || '--'}</span>
          },
        },
        {
          name: 'name',
          columnProps: {
            label: '门店名称',
            prop: 'name',
            width: 160,
          },
        },
        {
          name: 'cityName',
          columnProps: {
            label: '所属城市',
            prop: 'cityName',
            width: 160,
          },
        },
        {
          name: 'createTime',
          columnProps: {
            label: '创建时间',
            prop: 'createTime',
            width: 180,
          },
        },
        {
          name: 'address',
          columnProps: {
            label: '门店地址',
            prop: 'address',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const arr = [
              {
                label: '编辑',
                permission: this.judgePermission('company_handle_store'),
                action: () => this.handleEditStore(row),
              },
            ]
            return arr.filter((item) => item.permission)
          },
          type: 'operate',
        },
      ],
      apiFn: storeList,
    },
    isShowDepartment: false,
  }
  return configData
}
